import clsx from "clsx";
import type { PropsWithChildren } from "react";

const Container = ({
	children,
	className,
}: PropsWithChildren<{
	className?: string;
}>) => {
	return (
		<div
			className={clsx(
				"relative z-0 mx-auto max-w-screen-2xl px-3 pt-4 pb-6 sm:px-10 sm:pt-8 sm:pb-12",
				className,
			)}
		>
			{children}
		</div>
	);
};

export default Container;
